import { DateTimeFormatStyle } from "@hopper-b2b/i18n";
import {
  type Branding,
  ClientName,
  I18nNamespace,
  type TranslatableBrandAttributes,
  TranslationLanguage,
  ChatAvailability,
} from "@hopper-b2b/types";
import { CUSTOMER_SUPPORT_PATH } from "@hsbc/utilities";

const defaultConfig: TranslatableBrandAttributes = {
  dateFormat: "DD/MM/YYYY",
  portalName: "HSBC Rewards | Travel with Points",
  preferredCountryCode: "AE",
  preferredAreaCode: "+971",
  urls: {
    helpCenterBaseUrl: CUSTOMER_SUPPORT_PATH,
    termsAndConditions: "https://hts.hopper.com/legal/HSBC-UAE",
    privacyPolicy: "https://hts.hopper.com/legal/privacy-policy",
    cfarTerms: "https://hts.hopper.com/legal/HSBC-UAE",
    disruptionTerms: "https://hts.hopper.com/legal/HSBC-UAE",
    hsbcTerms: "https://www.hsbc.ae/terms/",
    benefitsFromAirline:
      "https://hts.hopper.com/legal/hts-passenger-rights-overview",
  },
  rewardsPriceFormatterKey: "{{amount}} Points",
  "@rewardsPriceFormatterKey": {
    description:
      "text - A number of points. PH({{amount}}|100|number of points)",
  },
  calendarMonthFormatStyle: DateTimeFormatStyle.Custom({
    month: "long",
    year: "numeric",
  }),
};

const arabicConfig: TranslatableBrandAttributes = {
  ...defaultConfig,
  rewardsPriceFormatterKey: "{{amount}} نقاط",
  urls: {
    ...defaultConfig.urls,
    termsAndConditions: "https://hts.hopper.com/legal/ar-HSBC-UAE",
    privacyPolicy: "https://hts.hopper.com/legal/ar-privacy-policy",
    cfarTerms: "https://hts.hopper.com/legal/ar-HSBC-UAE",
    disruptionTerms: "https://hts.hopper.com/legal/ar-HSBC-UAE",
    hsbcTerms: "https://www.hsbc.ae/ar-ae/terms/",
  },
};

export const branding: Branding = {
  clientName: ClientName.HSBC_UAE,
  currencies: [
    {
      locale: "en-AE",
      code: "AED",
      symbol: "AED",
      symbolOverride: "AED ",
    },
  ],
  contactSupport: {
    chatAvailability: ChatAvailability.None,
    displaySupportNumber: "+971 800 0120510",
    displayIntlSupportNumber: "+44 20 4632 1208",
    supportNumber: "+9718000120510",
    intlSupportNumber: "+442046321208",
  },
  [I18nNamespace.translation]: {
    [TranslationLanguage.ar]: arabicConfig,
    [TranslationLanguage["en-AE"]]: defaultConfig,
  },
  default: "en-AE",
  // TODO: AR is here for config only
  supportedLanguages: [
    { key: "en-AE", name: "English", label: "English" },
    { key: "ar", name: "Arabic", label: "العربية" },
  ],
  merchantPayments: "",
  hidePaymentZipCode: true,
  showAIChat: false,
};
